import { BaleAnalysisProvider } from 'features';
import { Outlet, useParams } from 'react-router-dom';

export const SiteMaterialAnalysisProvider = () => {
  const { siteMaterialId } = useParams<{ siteMaterialId: string }>();

  return (
    <BaleAnalysisProvider mode="site-material" parentId={String(siteMaterialId)}>
      <Outlet />
    </BaleAnalysisProvider>
  );
};
